import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AppStateService } from '../services/app-state.service';

export const tmaGuard: CanActivateFn = () => {
  const appState = inject(AppStateService);
  const router = inject(Router);

  if (appState.authenticated()) {
    return true;
  }

  return router.createUrlTree(['/init']);
};
